/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The TankInfo model module.
* @module model/TankInfo
* @version 2020-12-7
*/
export default class TankInfo {
    /**
    * Constructs a new <code>TankInfo</code>.
    * @alias module:model/TankInfo
    * @class
    * @param total {Number} 
    * @param sensorInstalled {Number} 
    */

    constructor(total, sensorInstalled) {
        
        
        this['total'] = total;
        this['sensorInstalled'] = sensorInstalled;
        
    }

    /**
    * Constructs a <code>TankInfo</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/TankInfo} obj Optional instance to populate.
    * @return {module:model/TankInfo} The populated <code>TankInfo</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TankInfo();
                        
            
            if (data.hasOwnProperty('total')) {
                obj['total'] = ApiClient.convertToType(data['total'], 'Number');
            }
            if (data.hasOwnProperty('sensorInstalled')) {
                obj['sensorInstalled'] = ApiClient.convertToType(data['sensorInstalled'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {Number} total
    */
    'total' = undefined;
    /**
    * @member {Number} sensorInstalled
    */
    'sensorInstalled' = undefined;




}
